import {useQuery} from '@tanstack/react-query';
import {api} from '../api.js';

export type ProjectMember = {principalType: 'user' | 'machine'; principalId: string; role: 'administrator' | 'member' | 'viewer'; createdAt: string; displayName: string; email: string | null};

export function useProjectMembers(projectId: string) {
  return useQuery({queryKey: ['project-members', projectId], queryFn: () => api<{items: ProjectMember[]}>(`/projects/${projectId}/members`).then(r => r.items), enabled: Boolean(projectId)});
}
